import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/children/SunShine/HomePage";
import Port from "@/components/children/SunShine/Port";
import Tax from "@/components/children/SunShine/Tax";
import Financing from "@/components/children/SunShine/Financing";
import Settlement from "@/components/children/SunShine/Settlement";
import SunShine from "@/components/SunShine";
import Product from "@/components/Product";
import Examples from "@/components/Examples";
import Business from "@/components/Business";
import Contact from "@/components/Contact";
import BToC from "@/components/BToC"
import BToB from "@/components/BToB"
import ShopView from "@/components/ShopView"
import EnterprisePage from "@/components/EnterprisePage"
import Policies from "@/components/Policies"
import About from "@/components/About"
import Introduce from "@/components/children/BToC/Introduce"
import Platform from "@/components/children/BToC/Platform"
import BToCExit from "@/components/children/BToC/BToCExit"
import ShopPage from "@/components/children/ShopView/ShopPage"
import ShopInfo from "@/components/children/ShopView/ShopInfo"
import EnterpriseView from "@/components/children/Enterprise/EnterpriseView"
import EnterpriseInfo from "@/components/children/Enterprise/EnterpriseInfo"
import Sales from "@/components/children/BToB/Sales"
import Terrace from "@/components/children/BToB/Terrace"
import BToBExit from "@/components/children/BToB/BToBExit"
import Customs from "@/components/children/Policies/Customs"
import LawsTax from "@/components/children/Policies/LawsTax"
import Outer from "@/components/children/Policies/Outer"
import CustomsDetail from "@/components/children/Policies/Detail/Customs"
import Conduct from '@/components/children/Enter/Conduct'
import Consult from '@/components/children/Enter/Consult'
import Customize from '@/components/children/Enter/Customize'
import Qualifications from '@/components/children/Enter/Qualifications'
Vue.use(Router);

export default new Router({
    routes: [{
            path: "/",
            name: "SunShine",
            component: SunShine,
            redirect: "/sunShine",
            children: [{
                path: "/sunShine",
                name: "SunShine",
                component: HomePage,
            }, {
                path: "/sunShine/port",
                name: "Port",
                component: Port,
            }, {
                path: "/sunShine/tax",
                name: "Tax",
                component: Tax,
            }, {
                path: "/sunShine/financing",
                name: "Financing",
                component: Financing,
            }, {
                path: "/sunShine/settlement",
                name: "Settlement",
                component: Settlement,
            }, {
                path: "/sunShine/conduct",
                name: "Conduct",
                component: Conduct,
            }, {
                path: "/sunShine/consult",
                name: "Consult",
                component: Consult,
            }, {
                path: "/sunShine/customize",
                name: "Customize",
                component: Customize,
            }, {
                path: "/sunShine/qualifications",
                name: "Qualifications",
                component: Qualifications,
            }]
        },
        {
            path: "/product",
            name: "Product",
            component: Product
        },
        {
            path: "/examples",
            name: "Examples",
            component: Examples
        },
        {
            path: "/business",
            name: "Business",
            component: Business
        },
        {
            path: "/contact",
            name: "Contact",
            component: Contact
        }, {
            path: "/btoC",
            name: "btoC",
            component: BToC,
            redirect: "/btoC/introduce",
            children: [{
                path: "/btoC/introduce",
                name: "introduce",
                component: Introduce
            }, {
                path: "/btoC/platform",
                name: "Platform",
                component: Platform
            }, {
                path: "/btoC/exit",
                name: "Exit",
                component: BToCExit
            }, ]
        }, {
            path: "/btoB",
            name: "btoB",
            component: BToB,
            redirect: "/btoB/sales",
            children: [{
                path: "/btoB/sales",
                name: "Sales",
                component: Sales
            }, {
                path: "/btoB/terrace",
                name: "Terrace",
                component: Terrace
            }, {
                path: "/btoB/exit",
                name: "Exit",
                component: BToBExit
            }, ]
        }, {
            path: "/shopView",
            name: "ShopView",
            component: ShopView,
            redirect: "/shopView",
            children: [
                {
                    path: "/shopView",
                    name: "ShopView",
                    component: ShopPage,
                }, {
                    path: "/shopView/shopInfo",
                    name: "ShopInfo",
                    component: ShopInfo
                }]
        },
        {
            path: "/enterpriseView",
            name: "EnterpriseView",
            component: EnterprisePage,
            redirect: "/enterpriseView",
            children: [
                {
                    path: "/enterpriseView",
                    name: "EnterpriseView",
                    component: EnterpriseView,
                }, {
                    path: "/enterpriseView/info",
                    name: "EnterpriseInfo",
                    component: EnterpriseInfo
                }]
        },{
            path: "/policies",
            name: "policies",
            component: Policies,
            redirect: "/policies/customs",
            children: [{
                path: "/policies/customs",
                name: "Customs",
                component: Customs
            }, {
                path: "/policies/lawsTax",
                name: "LawsTax",
                component: LawsTax
            }, {
                path: "/policies/outer",
                name: "Outer",
                component: Outer
            }, {
                path: "/policies/customs/:id",
                name: "CustomsDetail",
                component: CustomsDetail
            }, ]
        }, {
            path: "/about",
            name: "about",
            component: About
        }
    ],
    mode: "history"
});
// customs lawsTax  outer


// WEBPACK FOOTER //
// ./src/router/index.js